<template>
  <v-container>
    <v-row>
      <v-col class="d-flex flex-column flex-sm-row">
        <v-btn
          v-if="variant.technical_info"
          depressed
          class="mr-sm-1 mr-md-2 mb-2"
          :color="activeText === 'technical' ? 'primary' : 'info darken-2'"
          @click="activeText = 'technical'"
        >
          Specificaties
        </v-btn>
        <v-btn
          v-if="variant.general_info"
          depressed
          class="mr-sm-1 mr-md-2"
          :color="activeText === 'general' ? 'primary' : 'info darken-2'"
          @click="activeText = 'general'"
        >
          Productinformatie
        </v-btn>
        <v-btn
          v-if="variant.user_info"
          depressed
          class="mt-2 mt-sm-0 mr-sm-1 mr-md-2"
          :color="activeText === 'user' ? 'primary' : 'info darken-2'"
          @click="activeText = 'user'"
        >
          Licentie informatie
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <dynamic-text v-if="computedText.type === 'text'" class="tab-content" :html="computedText.content"/>
      <component
        :is="computedText.component"
        v-if="computedText.type === 'component'"
        v-bind="computedText.content"
      />
    </v-row>
  </v-container>
</template>

<script>
import CompareTable from '~/components/shop/CompareTable.vue';

export default {
  props: {
    variant: {
      type: Object,
      default: () => ({}),
    },
    product: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    activeText: 'technical',
  }),
  computed: {
    computedText() {
      switch (this.activeText) {
        case 'general':
          return {
            type: 'text',
            content: this.product.explanation,
          };
        case 'user':
          return {
            type: 'text',
            content: this.variant.user_info,
          };
        default:
          return {
            type: 'component',
            component: CompareTable,
            content: {htmlString: this.product.table},
          };
      }
    },
  },
};
</script>

<style lang="sass" scoped>
.tab-content
  padding: 0 25px 80px 25px

  ::v-deep p
    margin-bottom: 0

    & strong
      font-family: $heading-font-family
      font-size: map-deep-get($headings, 'h6', 'size') !important
      text-transform: uppercase
      color: var(--v-primary-lighten2)

  ::v-deep ol
    padding-left: 0

    & > ol
      padding-bottom: 16px

  ::v-deep ul,
  ::v-deep ol > ol
    list-style-type: none
    padding-left: 25px

    & > li
      position: relative
      text-indent: 26px

      &:before
        position: absolute
        content: ''
        left: 0
        right: calc(100% - 17px)
        top: 8px
        bottom: 0
        background: url('~assets/img/streep.svg') no-repeat
</style>
